import { Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Listbox, Transition } from "@headlessui/react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const CurrencyOptions = (props) => {
  const { selectedCurrency, ticketArray } = props;
  let currencyList = ticketArray?.currency ?? [];

  const setSelected = (e) => {
    // console.log(e);
    props.currencyChange(e);
  };

  return (
    <Listbox value={selectedCurrency} onChange={setSelected}>
      {({ open }) => (
        <>
          <div className="relative w-24">
            <Listbox.Button className="relative w-full cursor-default rounded-md border border-default bg-white py-1.5 pl-3 pr-10 text-left text-primary shadow-sm focus:outline-none sm:text-sm sm:leading-6">
              <span className="block truncate">{selectedCurrency}</span>
              <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                <ChevronUpDownIcon
                  className="h-5 w-5 text-gray-400"
                  aria-hidden="true"
                />
              </span>
            </Listbox.Button>

            <Transition
              show={open}
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                {currencyList.map((currency) => (
                  <Listbox.Option
                    key={currency}
                    className={({ active }) =>
                      classNames(
                        active ? "bg-default" : "text-primary",
                        "relative cursor-default select-none py-2 pl-3 pr-9"
                      )
                    }
                    value={currency}
                  >
                    {({ selected, active }) => (
                      <>
                        <span
                          className={classNames(
                            selected ? "font-semibold" : "font-normal",
                            "block truncate"
                          )}
                        >
                          {currency}
                        </span>

                        {selected ? (
                          <span
                            className={classNames(
                              active ? "text-theme" : "text-theme",
                              "absolute inset-y-0 right-0 flex items-center pr-4"
                            )}
                          >
                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                          </span>
                        ) : null}
                      </>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </Transition>
          </div>
        </>
      )}
    </Listbox>
  );
};

const mapStateToProps = (state) => {
  return { ticketArray: state.ticketLists };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(CurrencyOptions);
